import { connect, MapStateToProps } from 'react-redux';
import { Props } from './BasePageLayout';
import { AppState } from '../../../../types/store';
import { getCurrentFeedType, getLayout } from '../../../../selectors/page';

export type StateProps = Pick<Props, 'feedType' | 'layout'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  feedType: getCurrentFeedType(state),
  layout: getLayout(state),
});

export default connect(mapStateToProps);
